<template>
  <div id="vehicleList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>车辆管理</el-breadcrumb-item>
      <el-breadcrumb-item>车辆列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="table-container">
      <div class="table-filtrate">
        <ul>
          <li>
            <span class="label">输入关键字:</span>
            <el-input
              placeholder="请输入内容"
              v-model="filtrate.keyword"
              @keyup.enter.native="getList(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getList(1)"
              ></el-button>
            </el-input>
          </li>
          <li>
            <span class="label">车辆类型:</span>
            <el-select
              v-model="filtrate.vehicleType"
              clearable
              placeholder="请选择"
              @change="getList(1)"
            >
              <el-option
                v-for="item in filtrate.vehicleTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </li>
          <li>
            <el-button type="primary" size="medium" @click="getList(1)"
              >查询</el-button
            >
          </li>
          <li>
            <el-button class="resetBtn" size="medium" @click="reset"
              >重置</el-button
            >
          </li>
        </ul>
        <ul>
          <li>
            <el-button
              class="addVehicle"
              type="primary"
              @click="addVehicle"
              v-if="buttonList.includes('vehicleList-addVehicle')"
              ><i class="iconfont icon-jiahao"></i> 新建车辆</el-button
            >
          </li>
        </ul>
      </div>
      <el-table
        :data="table.tableData"
        style="width: 100%"
        v-loading="table.loading"
      >
        <el-table-column prop="plateNum" label="车牌号" align="center">
        </el-table-column>
        <el-table-column prop="vehicleType" label="车辆类型" align="center">
        </el-table-column>
        <el-table-column prop="vehicleSize" label="车辆大小" align="center">
        </el-table-column>
        <el-table-column prop="vehicleColor" label="车辆颜色" align="center">
        </el-table-column>
        <el-table-column prop="vehicleBrand" label="车辆品牌" align="center">
        </el-table-column>
        <el-table-column prop="bindNum" label="绑定人数" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="goToDetail(scope.row.vehicleId)"
              v-if="buttonList.includes('vehicleList-detail')"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="sizes, total, prev, pager, next, jumper"
          background
          :total="table.total"
          :page-size.sync="table.pageSize"
          :current-page.sync="table.page"
          @current-change="getList"
          @size-change="getList(1)"
        >
        </el-pagination>
      </div>
    </div>
    <add-vehicle-dialog ref="addVehicleDialog" :getList="getList" />
  </div>
</template>
<script>
import addVehicleDialog from "./addVehicleDialog.vue";
export default {
  components: {
    addVehicleDialog,
  },
  data() {
    return {
      filtrate: {
        keyword: "",
        vehicleType: null,
        vehicleTypeList: [
          {
            value: "普通",
            babel: "普通",
          },
          {
            value: "新能源",
            babel: "新能源",
          },
        ],
      },
      table: {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 10,
        loading: false,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    addVehicle() {
      this.$refs.addVehicleDialog.show = true;
    },
    reset() {
      this.filtrate.keyword = "";
      this.filtrate.vehicleType = null;
      this.getList(1);
    },
    goToDetail(vehicleId) {
      this.$router.push({ name: "vehicleDetail", params: { id: vehicleId } });
    },
    async getList(page = this.table.page) {
      this.table.page = page;
      try {
        this.table.loading = true;
        let res = await this.$http.post("/vehicle/list", {
          pageNum: page,
          pageSize: this.table.pageSize,
          keyword: this.filtrate.keyword,
          parkingLotId: this.filtrate.parkingLotId,
          vehicleType: this.filtrate.vehicleType
            ? this.filtrate.vehicleType
            : null,
        });
        if (res.code === 0) {
          this.table.tableData = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.table.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#vehicleList {
  .table-container {
    .table-filtrate {
      ul {
        li {
          .addVehicle {
            background-color: #ff9747;
            border-color: #ff9747;
            i {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
